import * as React from "react";
import * as Yup from "yup";
import axios from "axios";
import { Formik } from "formik";
import HtmlParser from 'html-react-parser';
import '../scss/components/_demo-form-modal.scss';
import { mailDomainsBlacklist, fieldsFilter, hubspot_generalForm_fields } from '../utils/hubspot_utils.js';


const PORTAL_ID = '7284441';
const FORM_ID = 'b0bc5e22-8edc-4222-aa58-1cf62ee80355';

// import { globalHistory as history } from '@reach/router';

function toFormGroupClass(field, state, error) {
  if (state.touched[field] && (state.errors[field] || error)) {
    return "pt-form-group pt-intent-danger";
  } else if (
    state.touched[field] &&
    state.values &&
    state.values[field] !== ""
  ) {
    return "pt-form-group pt-intent-success";
  } else {
    return "pt-form-group";
  }
}


export class DemoFormModal extends React.Component {


  state = { error: false,  mailError: false, submitted: false };

  validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Must be a valid email")
      .matches(mailDomainsBlacklist, "Company Email Only")
      .required("Required")

  });


  handleSubmit = async (values, { resetForm }) => {
    values.source = this.props.source ? this.props.source : HtmlParser("");

    const url = typeof window !== 'undefined' ? window.location.href : '';
    const pageTitle = typeof document !== 'undefined' ? document.title : '';

    const UTMparams = JSON.parse(sessionStorage.getItem('UTMparams'));
    const referrer = sessionStorage.getItem('Referrer');  
    
    const fields = [
      {name: 'email', value: values.email},
      {name: 'how_did_you_hear_about_us_', value: values.note },
    ]
    
    if (UTMparams && typeof UTMparams[0] === "string" ){
      fields.push({name: UTMparams[0], value: UTMparams[1]})
      
    } else if (UTMparams) {
      UTMparams.forEach(property => {
        fields.push({name: property[0], value: property[1]})
      })
    }
    
    fields.push({name: "referrer", value: referrer || "Empty"});
    const context = {
      pageUri: url,
      pageName: pageTitle
    }

    const filteredFieldsArray = fieldsFilter(fields, hubspot_generalForm_fields);

    try {
      // ============ Sending to Hubspot ============ // 
      await axios.request({
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        url: `https://api.hsforms.com/submissions/v3/integration/submit/${PORTAL_ID}/${FORM_ID}`,
        data: JSON.stringify({
          fields: filteredFieldsArray,
          context: context
        })
      })
      
      this.setState({ submitted: true });

    } catch (error) {
      this.setState({ error: true })
      return
    }

    // ============ Sending to Charthop API (Slack) ============ //
    await axios.request({
      method: "POST",
      url: "https://api.charthop.com/contact",
      data: {...values}
    })

  };

  render() {

    if (this.state.submitted) {
      return (
        <div className="pt-callout pt-intent-primary pt-submission-success-modal mb-1">
          <img src={'/home/successfulFormSubmission.svg'} alt="The ChartHop logo" />
          <p>Thanks for your interest in ChartHop!</p>
          <p>We'll be in touch soon.</p>
        </div>
      );
    }

    return (
    
      <div className="container">
        <div className="row align-items-top justify-content-around pb-1">
        <h2 style={{fontSize:"30px"}}>Let's chat!</h2>
          <div className="pl-md-2 pr-md-2 longFormParentContainer col-12" >
            <Formik
              initialValues={{ name: "", email: "", company_size: "", note: "", source: "" }}
              validationSchema={this.validationSchema}
              onSubmit={this.handleSubmit}
              render={form => (
                <form className="demoModalform" onSubmit={form.handleSubmit}>

                <div className={toFormGroupClass("email", form)} >
                  <label className="pt-label" htmlFor="email">
                    {/* Company Email */}<span hidden>Company Email</span>
                  </label>
                  <div className="pt-form-email-container">
                    <input
                        id="email"
                        name="email"
                        type="text"
                        className="input-text companyEmail"
                        value={form.values.email}
                        onChange={form.handleChange}
                        placeholder="Company Email"
                      />
                      <img alt="error" className="pt-form-image pt-form-image-danger" src="/icons/Icon-material-error-outline.svg"/>
                      <img alt="complete" className="pt-form-image pt-form-image-success" src="/icons/Icon-material-done.svg"/>
                  </div>

                  {form.touched.email && form.errors.email && (
                    <div className="pt-form-helper-text">{form.errors.email}</div>
                  )}

                </div>

                <div className="pt-form-group">
                  <label className="pt-label" htmlFor="note">
                    {/* How did you hear about us? */}
                    <span hidden>How did you hear about us?</span>
                  </label>
                  <input
                  className="input-text"
                    type="text"
                    id="note"
                    value={form.values.note}
                    onChange={form.handleChange}
                    placeholder="How did you hear about us?"
                  />
                </div>

              
                <div className="text-center">
                  <center>
                    <button ref={btn => { this.btn = btn; }} type="submit" style={{backgroundColor:this.props.buttonColor}}className="button primary">
                      {this.props.buttonText}
                    </button>
                  </center>
                  <p className="modal-form-footer">By submitting your info, you agree to opt-in to emails from ChartHop.</p>
                </div>
                
                {this.state.mailError && (
                  <div className="pt-callout pt-intent-danger" style={{ marginTop: 10 }}>
                    Sorry! Please use a company email. If your issue persists, send a note to {" "}
                    <a href="mailto:hello@charthop.com">hello@charthop.com</a>.
                  </div>
                )}

                {this.state.error && (
                  <div className="pt-callout pt-intent-danger mt-1">
                    Sorry, but we had an unexpected problem submitting your request.
                    Try again later, or send a note to{" "}
                    <a href="mailto:hello@charthop.com">hello@charthop.com</a>.
                  </div>
                )}
              </form>

              )}
            />
          </div>

        </div>
      </div>
    );
  }
} 